/**
 * GRANNY TODU — Sold Out Quick Add Interceptor + Success Popup
 * assets/soldout-quickadd.js
 */

(function() {
  var assets = window.grannyAssets || {};

  // ── SOLDOUT POPUP ──────────────────────────────────────────
  function injectSoldoutPopup() {
    if (document.getElementById('grannySoldoutOverlay')) return;

    var overlay = document.createElement('div');
    overlay.id = 'grannySoldoutOverlay';
    overlay.style.cssText = 'display:none;position:fixed;inset:0;background:rgba(0,0,0,.65);z-index:99999;align-items:center;justify-content:center;';

    overlay.innerHTML =
      '<div style="position:relative;max-width:420px;width:90%;">' +
        '<button id="grannySoldoutClose" style="position:absolute;top:-14px;right:-14px;background:#e91e8c;color:white;border:none;border-radius:50%;width:30px;height:30px;font-size:16px;cursor:pointer;z-index:10;line-height:1;">✕</button>' +
        '<div style="position:relative;">' +
          '<img src="' + (assets.soldoutBanner || '') + '" alt="Sold out" style="width:100%;height:auto;display:block;border-radius:12px;">' +
          '<a id="grannySoldoutWishLink" href="/pages/make-a-wish" style="position:absolute;bottom:10%;left:50%;transform:translateX(-50%);width:60%;display:block;">' +
            '<img src="' + (assets.stillWant || '') + '" alt="I still want it" style="width:100%;height:auto;display:block;">' +
          '</a>' +
        '</div>' +
      '</div>';

    document.body.appendChild(overlay);

    document.getElementById('grannySoldoutClose').addEventListener('click', function() {
      overlay.style.display = 'none';
    });
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) overlay.style.display = 'none';
    });

    window.showSoldoutPopup = function(title, handle) {
      var link = document.getElementById('grannySoldoutWishLink');
      if (link) link.href = '/pages/make-a-wish?product_title=' + encodeURIComponent(title) + '&product_handle=' + encodeURIComponent(handle);
      overlay.style.display = 'flex';
    };
  }

  // ── SUCCESS POPUP ──────────────────────────────────────────
  function injectSuccessPopup() {
    if (document.getElementById('grannySuccessOverlay')) return;

    var overlay = document.createElement('div');
    overlay.id = 'grannySuccessOverlay';
    overlay.style.cssText = 'display:none;position:fixed;inset:0;background:rgba(0,0,0,.65);z-index:99999;align-items:center;justify-content:center;';

    overlay.innerHTML =
      '<div style="position:relative;max-width:440px;width:90%;">' +
        '<button id="grannySuccessClose" style="position:absolute;top:-14px;right:-14px;background:#e91e8c;color:white;border:none;border-radius:50%;width:30px;height:30px;font-size:16px;cursor:pointer;z-index:10;line-height:1;">✕</button>' +
        '<img src="' + (assets.wishConfirmation || '') + '" alt="Wish sent!" style="width:100%;height:auto;display:block;border-radius:12px;">' +
        '<div id="grannySuccessCelebration" style="position:absolute;inset:0;pointer-events:none;overflow:visible;"></div>' +
      '</div>';

    document.body.appendChild(overlay);

    document.getElementById('grannySuccessClose').addEventListener('click', function() {
      overlay.style.display = 'none';
    });
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) overlay.style.display = 'none';
    });

    window.showSuccessPopup = function() {
      overlay.style.display = 'flex';
      launchCelebration();
    };
  }

  function launchCelebration() {
    var container = document.getElementById('grannySuccessCelebration');
    if (!container) return;
    var imgs = [assets.heartFilled, assets.heartStar].filter(Boolean);
    if (!imgs.length) return;
    for (var i = 0; i < 16; i++) {
      (function(i) {
        setTimeout(function() {
          var el = document.createElement('img');
          el.src = imgs[Math.floor(Math.random() * imgs.length)];
          el.style.cssText = 'position:absolute;width:28px;height:28px;image-rendering:pixelated;animation:grannyFloat 2s ease-out forwards;left:' + (5 + Math.random() * 90) + '%;bottom:' + (10 + Math.random() * 50) + '%;animation-delay:' + (Math.random() * 0.3) + 's;';
          container.appendChild(el);
          setTimeout(function() { el.remove(); }, 2500);
        }, i * 80);
      })(i);
    }
  }

  var styleEl = document.createElement('style');
  styleEl.textContent = '@keyframes grannyFloat{0%{transform:translateY(0) scale(1);opacity:1}100%{transform:translateY(-200px) scale(0.4) rotate(25deg);opacity:0}}';
  document.head.appendChild(styleEl);

  // ── KEY FIX: listen on WRAPPER not disabled button ─────────
  // Disabled buttons swallow clicks — intercept at document level
  // but target the quick-add wrapper area
  document.addEventListener('click', function(event) {
    // Check if click is on or inside a quick-add component
    var quickAdd = event.target.closest('quick-add-component');
    if (!quickAdd) return;

    // Find the soldout button inside it
    var soldoutBtn = quickAdd.querySelector('.quick-add__button--add[data-soldout="true"]');
    if (!soldoutBtn) return;

    // Only intercept if they clicked in the button area
    var btn = event.target.closest('.quick-add__button--add');
    if (!btn) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var title = soldoutBtn.dataset.productTitle || '';
    var handle = soldoutBtn.dataset.productHandle || '';
    window.showSoldoutPopup(title, handle);
  }, true);

  // Also wrap disabled button in a clickable div via DOM mutation
  function wrapSoldoutButtons() {
    document.querySelectorAll('.quick-add__button--add[data-soldout="true"]').forEach(function(btn) {
      if (btn.dataset.wrapped) return;
      btn.dataset.wrapped = 'true';

      var wrapper = document.createElement('div');
      wrapper.style.cssText = 'position:absolute;inset:0;z-index:20;cursor:pointer;';
      wrapper.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var title = btn.dataset.productTitle || '';
        var handle = btn.dataset.productHandle || '';
        window.showSoldoutPopup(title, handle);
      });

      btn.style.position = 'relative';
      btn.appendChild(wrapper);
    });
  }

  function init() {
    injectSoldoutPopup();
    injectSuccessPopup();
    wrapSoldoutButtons();

    // Re-run when new content loads (carousels, dynamic sections)
    var observer = new MutationObserver(function() {
      wrapSoldoutButtons();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
